import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Flex, Box } from 'reflexbox';
import { Checkbox, Text } from 'rebass';

import config from 'frontend/config';
import actions from 'frontend/state/actions';
import { selectors as formSelectors } from 'frontend/state/reducers/simbot/form';

const BrowserNotificationToggle = ({ sendBrowserNotification, toggleBrowserNotification }) => {
  if (!window.Notification) {
    return null;
  }
  return (
    <Flex mb={2}>
      <Box mr={1}>
        <Checkbox
          name="sendBrowserNotification"
          label="Send browser notification when report is complete"
          checked={sendBrowserNotification}
          onChange={toggleBrowserNotification}
          backgroundColor={config.colors.black}
        />
      </Box>
      {_.get(window, 'Notification.permission') === 'denied' && (
      <Box>
        <Text small>(You have denied notification access, check browser settings to reset)</Text>
      </Box>
      )}
    </Flex>
  );
};

BrowserNotificationToggle.propTypes = {
  sendBrowserNotification: PropTypes.bool.isRequired,
  toggleBrowserNotification: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  sendBrowserNotification: formSelectors.sendBrowserNotification(state),
});

const mapDispatchToProps = {
  toggleBrowserNotification: actions.toggleBrowserNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrowserNotificationToggle);
